import { QUERY_KEY_MY_MONITORING_GET_SITE_EVENTS_INFINITE } from '@apps-common/apis/my-monitoring/site'
import { QUERY_MY_MONITORING_GET_SITE_ZONE } from '@apps-common/apis/my-monitoring/zones/get-site-zone'
import { QUERY_MY_MONITORING_GET_SITE_ZONES } from '@apps-common/apis/my-monitoring/zones/get-site-zones'
import { QUERY_GET_UNIT_TRAFFIC_INFINITE } from '@apps-common/apis/portal/unit'
import { QUERY_GET_UNIT_CUSTOM_ZONE, QUERY_GET_UNIT_CUSTOM_ZONES } from '@apps-common/apis/portal/zones'
import { ZoneAddForm, ZoneUpdateForm } from '@apps-common/apps/portal/pages/units/pages/manage/pages/zones/modals/zone-modify-modal'
import { ModalCloseButton, ModalContainer, ModalHeader, ModalHeaderContainer } from '@apps-common/components/modals/modal'
import { ModalDismiss } from '@apps-common/config/modal'
import { queryClient } from '@apps-common/lib'

export interface IUnitZoneModifyModalProps {
  unitId: string
  zoneId?: number
}

export const ZoneModifyModal = ({
  onDismiss,
  componentProps
}: {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
  componentProps: IUnitZoneModifyModalProps
}) => {
  const { unitId, zoneId } = componentProps
  const isEditing = !!zoneId && !Number.isNaN(zoneId)

  const refetchQueries = (role: string) => {
    if (role === ModalDismiss.Confirm) {
      // my monitoring
      queryClient.refetchQueries({ queryKey: QUERY_MY_MONITORING_GET_SITE_ZONE(zoneId) })
      queryClient.refetchQueries({ queryKey: QUERY_MY_MONITORING_GET_SITE_ZONES(unitId) })
      queryClient.invalidateQueries({ queryKey: QUERY_KEY_MY_MONITORING_GET_SITE_EVENTS_INFINITE() })
      // portal
      queryClient.refetchQueries({ queryKey: QUERY_GET_UNIT_CUSTOM_ZONE(zoneId) })
      queryClient.refetchQueries({ queryKey: QUERY_GET_UNIT_CUSTOM_ZONES(unitId) })
      queryClient.invalidateQueries({ queryKey: QUERY_GET_UNIT_TRAFFIC_INFINITE() })
    }
  }

  return (
    <ModalContainer innerClasses='!h-auto !min-h-0'>
      <ModalHeaderContainer>
        <div className='flex items-start justify-between'>
          <ModalHeader subtitle={isEditing ? 'Update' : 'Create'} title='Zone Description' />
          <ModalCloseButton closeModal={() => onDismiss(null, ModalDismiss.Cancel)} />
        </div>
      </ModalHeaderContainer>
      {!isEditing && (
        <ZoneAddForm
          unitId={unitId}
          closeCb={(role: string) => {
            refetchQueries(role)
            onDismiss(null, role)
          }}
        />
      )}
      {isEditing && (
        <ZoneUpdateForm
          zoneId={zoneId}
          unitId={unitId}
          closeCb={(role: string) => {
            refetchQueries(role)
            onDismiss(null, role)
          }}
        />
      )}
    </ModalContainer>
  )
}
